export default __webpack_public_path__ + "static/media/medical-report.02652928.svg";